import React, { useState } from 'react';
import * as Yup from 'yup';

import { Row, Col, Button } from 'react-bootstrap';

import {
  Formik,
  Form as FormikForm,
  FieldArray,
} from 'formik';

import {
  TextField,
  SubmitButton,
  CancelPopupButton,
  CheckBoxField,
  SelectFieldV2,
} from 'ui/FormElement';

import { useContext as usePolicyTemplatesContext } from 'components/Common/PolicyTemplates/Context';
import useCustomServices from 'components/Common/PlanCustomServices/Hooks/useCustomServices';

import activationFeeTypes from 'data/activation_fee_types';

import deleteIcon from 'images/icons/invite/delete.svg';

export default function Form({ template, onClose }) {
  const { dispatch, actions, state } = usePolicyTemplatesContext();
  const { services } = useCustomServices();

  const FormSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    items: Yup.array().of(
      Yup.object().shape({
        title: Yup.string().required('required'),
      }),
    ),
  });

  const [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState(
    {
      title: template.attributes.title,
      price_scale: template.attributes.price_scale,
      contact_sales: template.attributes.contact_sales,
      is_free: template.attributes.is_free,
      items: template.attributes.items,
      policy_plan_custom_record_template_id: template.attributes.policy_plan_custom_record_template_id,
      activate_without_platform: template.attributes.activate_without_platform,
      activation_fee_type: template.attributes.activation_fee_type,
    },
  );

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.update(
      dispatch,
      template.id,
      values,
      () => {
        setLoader(false);
        onClose();
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      },
    );
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      {({ values }) => (
        <FormikForm className="needs-validation" noValidate="">
          <TextField
            name="title"
            label={(
              <>
                <span>Title</span>
                <abbr title="required">*</abbr>
              </>
          )}
          />
          <TextField
            name="price_scale"
            label={(
              <span>Price Scale</span>
          )}
          />

          <CheckBoxField
            name="contact_sales"
            inline
            label={(
              <span>Contact Sales</span>
                  )}
          />

          <CheckBoxField
            name="is_free"
            inline
            label={(
              <span>Free Category</span>
                  )}
          />

          <FieldArray name="items">
            {({ remove, push }) => (
              <div className="mt20">
                <h3>Overview</h3>
                {values.items.map(
                  (item, index) => (
                    <Row key={index}>
                      <Col md={10}>
                        <TextField
                          name={`items.${index}.title`}
                          placeholder="Title"
                        />
                      </Col>
                      <Col md={2}>
                        <a onClick={() => remove(index)}>
                          <img src={deleteIcon} />
                        </a>
                      </Col>
                    </Row>
                  ),
                )}

                <div className="text-right">
                  <Button
                    onClick={() => push({ title: '' })}
                    bsStyle="primary"
                  >
                    Add Item
                  </Button>
                </div>
              </div>
            )}
          </FieldArray>

          <SelectFieldV2
            name="policy_plan_custom_record_template_id"
            placeholder={services === null ? 'Loading Activation Fee' : 'Select Activation Fee'}
            isMulti={false}
            isClearable
            options={services === null ? [] : services.map((item) => ({
              label: item.attributes.name,
              value: parseInt(item.id, 10),
            }))}
            label={(
              <span>Activation Fee</span>
            )}
            menuPlacement="top"
          />

          <SelectFieldV2
            name="activation_fee_type"
            placeholder="Select Activation Fee Type"
            isMulti={false}
            isClearable
            options={activationFeeTypes}
            label={(
              <span>Activation Fee Type</span>
            )}
          />

          <CheckBoxField
            name="activate_without_platform"
            inline
            label={(
              <span>Activate without Platform Plan</span>
                  )}
          />

          <div className="text-center mt50 mb30">
            <CancelPopupButton
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              title="Cancel"
              onClick={onClose}
            />
            <SubmitButton
              title={loader ? 'Please, wait ...' : 'Save'}
              className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                loader ? 'not-possible-click' : ''
              }`}
            />
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}
